import Vue from 'vue'
Vue.filter('textOverflow', (value, length) => {
  if (value) {
    if (value.length > length) {
      return value.substring(0, length) + '...'
    } else {
      return value
    }
  }
})
Vue.filter('formatDate', value => {
  var theTime = parseInt(value) // 秒
  var middle = 0 // 分
  var hour = 0 // 小时

  if (theTime >= 60) {
    middle = parseInt(theTime / 60)
    theTime = parseInt(theTime % 60)
    if (middle >= 60) {
      hour = parseInt(middle / 60)
      middle = parseInt(middle % 60)
    }
  }
  var result = null
  if (theTime < 10) {
    result = '0' + parseInt(theTime)
  } else {
    result = '' + parseInt(theTime)
  }

  if (middle > 0) {
    if (middle < 10) {
      result = '0' + parseInt(middle) + ':' + result
    } else {
      result = '' + parseInt(middle) + ':' + result
    }
  } else {
    result = '0' + parseInt(middle) + ':' + result
  }
  if (hour > 0) {
    result = '' + parseInt(hour) + ':' + result
  } else {
    result = '00:' + result
  }
  return result
})
